<template>
  <div v-if="isShowAnnoucement" class="announcement">
    <div
      v-for="item in annoucementList"
      :id="`announce_${item.id}`"
      ref="announceItem"
      :key="item.id"
      class="comment-announcement"
      @click="clickArea(item.id)"
    >
      <div class="announce-icon icon" />
      <div class="announce-content" @click="jump2TargetPage(item.contentLink)">
        {{ resolveAnnounceContent(item.content) }}
      </div>
      <div
        v-if="item.contentLink"
        class="announce-jump icon"
        @click="jump2TargetPage(item.contentLink)"
      />
      <div v-else class="announce-close icon" @click="changeShowStatus(item.id)" />
    </div>
  </div>
</template>

<script lang="ts">
import { useAnnouncement, useStat } from '@cpc/comment-sdk-core-comment';
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'CommentAnnouncement',

  // props: {},

  setup() {
    const {
      annoucementList,
      isShowAnnoucement,
      isContentLinkActive,
      resolveAnnounceContent,

      fetchAnnoucement,
      jump2TargetPage,
    } = useAnnouncement();

    const { commentStat } = useStat();

    const announceItem = ref(null);

    const changeShowStatus = (noticeId: string) => {
      announceItem.value.style.display = 'none';

      commentStat('close_notice', { noticeId });
    };

    const clickArea = (noticeId: string) => {
      commentStat('click_notice', { noticeId });
    };

    fetchAnnoucement().then(() => {
      if (isShowAnnoucement.value) {
        commentStat('get_notice_expose', { noticeId: annoucementList.value[0].id }); // 目前只有一条
      }
    });

    return {
      announceItem,
      annoucementList,
      isShowAnnoucement,
      isContentLinkActive,
      resolveAnnounceContent,
      fetchAnnoucement,

      jump2TargetPage,
      changeShowStatus,
      clickArea,
    };
  },
});
</script>

<style lang="scss" scoped>
.announcement {
  margin-top: 15px;
  margin-bottom: 39px;
}
.comment-announcement {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  background: #ffffff;
  border-radius: 30px;

  width: 984px;
  height: 120px;
}

.announce-content {
  flex-grow: 1;
  font-size: 36px;
  line-height: 48px;
  color: rgba(0, 0, 0, 0.55);
}

.icon {
  background-repeat: no-repeat;
  background-size: contain;
}

.announce-icon {
  // TODO 暂时写死 后续根据type选择
  flex-basis: 72px;
  width: 72px;
  height: 72px;

  background-image: url('../assets/img/announce-icon.png');

  margin: 24px 36px 24px 51px;
}

.announce-close {
  flex-basis: 48px;
  width: 48px;
  height: 48px;

  background-image: url('../assets/img/announce-close.png');

  margin: 36px 45px 36px 84px;
}

.announce-jump {
  flex-basis: 72px;
  width: 72px;
  height: 72px;

  background-image: url('../assets/img/announce-jump.png');

  margin: 24px 39px 27px 48px;
}

html[data-theme='dark'] {
  .comment-announcement {
    background: #424242;
  }

  .icon {
    background-repeat: no-repeat;
    background-size: contain;
  }

  .announce-icon {
    background-image: url('../assets/img/announce-icon-dark.png');
  }

  .announce-jump {
    background-image: url('../assets/img/announce-jump-dark.png');
  }

  .announce-close {
    background-image: url('../assets/img/announce-close-dark.png');
  }
}
</style>
